module.exports = __webpack_public_path__ + "static/img/dl.93a3dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dl.png
// module id = vk+v
// module chunks = 94